/** A settings row with a switch: label, a quieter line under it, and the track on the right. */
const Toggle = ({ label, sub, on, onChange, disabled = false }) => (
  <button type="button" className="toggle-row" role="switch" aria-checked={on} aria-label={label} disabled={disabled} onClick={() => onChange(!on)}>
    <span className="grow">
      <span className="toggle-label">{label}</span>
      {sub && <span className="toggle-sub">{sub}</span>}
    </span>
    <span className={`toggle-track${on ? " on" : ""}`} aria-hidden="true">
      <span className="toggle-knob" />
    </span>
  </button>
);

export default Toggle;
